import { valueToTitle } from "../../../helpers";

export default function valuesToSettings<T>(values: T[]) {
  return values.map((value) => {
    return { value: value, title: valueToTitle(value as string) };
  });
}
